import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
class Loading extends React.Component {
  render() {
    const { loading , loading_status} = this.props;
    return (
      <Backdrop
        sx={{ color: '#fff', zIndex: 1000000000,display:"flex",flexDirection:"column"}}
        open={loading || false}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
        
        {String(loading_status).length > 0 && <div style={{marginTop:"5px",paddingTop:"20px",fontSize:"20px", fontWeight:"bold",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>{loading_status}</div>}
      </Backdrop>
    );
  }
}
export default Loading;